<template>
    <v-navigation-drawer
        v-if="viewDetailsDrawer"
        right
        app
        :width="480"
    >
		<medical-staff-view v-if="$route.path === '/medicalstaff'"/>
		<AssessmentsView v-if="$route.path === '/wellnessassessments'"/>
		<VerifierView v-if="$route.path ==='/verifier'"></VerifierView>
		<MedicalInstitutionView v-if="$route.path ==='/organizations'"></MedicalInstitutionView>
		<HospitalView v-if="$route.path ==='/offices'"></HospitalView>
		<OrganizationMappingView v-if="$route.path ==='/organizationMapping'"></OrganizationMappingView>
		<LocationMappingView v-if="$route.path ==='/locationMapping'"></LocationMappingView>
		<HospitalAdminView v-if="$route.path ==='/admins'"></HospitalAdminView>
		<MonitoringView v-if="$route.path==='/monitoring'"></MonitoringView>
		<MonitoringView v-if="$route.path==='/monitoring'"></MonitoringView>
		<ViewLicense v-if="$route.path==='/licenses'"></ViewLicense>
		<ViewTablets v-if="$route.path==='/tablets'"></ViewTablets>
		<OrganizationMappingViewPcc v-if="$route.path ==='/organizationMappingPcc'"></OrganizationMappingViewPcc>
		<LocationMappingViewPcc v-if="$route.path ==='/pccLocationMapping'"></LocationMappingViewPcc>

    </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MedicalStaffView from '@/views/DrawerDialogs/MedicalStaffView.vue';
import AssessmentsView from '@/views/DrawerDialogs/AssessmentsView.vue';
import VerifierView from '@/views/DrawerDialogs/VerifierView.vue';
import MedicalInstitutionView from '@/views/DrawerDialogs/MedicalInstitutionView';
import HospitalView from '@/views/DrawerDialogs/HospitalView';
import OrganizationMappingView from '@/views/DrawerDialogs/OrganizationMappingView';
import OrganizationMappingViewPcc from '@/views/DrawerDialogs/OrganizationMappingViewPcc';
import LocationMappingView from '@/views/DrawerDialogs/LocationMappingView';
import HospitalAdminView from '@/views/DrawerDialogs/HospitalAdminView';
import MonitoringView from '@/views/DrawerDialogs/MonitoringView';
import ViewLicense from '@/views/DrawerDialogs/ViewLicense.vue';
import LocationMappingViewPcc from '../DrawerDialogs/LocationMappingViewPcc.vue';

export default {
	components: {
		AssessmentsView,
		MedicalStaffView,
		VerifierView,
		MedicalInstitutionView,
		HospitalView,
		HospitalAdminView,
    MonitoringView,
    ViewLicense,
		OrganizationMappingView,
		LocationMappingView,
		OrganizationMappingViewPcc,
		LocationMappingViewPcc,
	},
	data () {
		return {
			showDrawer: true,
			items: [
				{ title: 'Home', icon: 'mdi-view-dashboard' },
				{ title: 'About', icon: 'mdi-forum' },
			],
		};
	},
	computed: {
		...mapState(['barColor', 'barImage', 'webrtcErrors', 'pageSize'],
		),
		...mapGetters({
			pageWidth: 'pageHeight',
			getPccSelectedLocation: 'mapping/getPccSelectedLocation',
		}),
		viewDetailsDrawer: {
			get () {
				return this.$store.state.viewDetailsDrawer;
			},
		},
	},
};
</script>
